<div class="addContainer">
  <div class="modalHeader">
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="table-img">
          <img class="notice-object" src="assets/images/user/user.png" alt="avatar">
        </div>
        <div class="modal-about">
          <div class="font-weight-bold p-t-5 p-l-10 font-17">
            {{dialogTitle}}
            <h6>REPORTE DE FALLA - MANTENIMIENTO CORRECTIVO</h6>
          </div>
        </div>
      </div>
    </div>
    <button mat-icon-button (click)="onNoClick()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form class="register-form m-4" [formGroup]="fallaForm">

      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width " appearance="outline">
            <mat-label>Tipo de Equipo</mat-label>
            <mat-select formControlName="reportefalla_tipoequipo" (selectionChange)="cambiarTipoEquipo()">
              <mat-option [value]="value.value" *ngFor="let value of tipoEquipoList">
                {{value.label}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="fallaForm.get('reportefalla_tipoequipo').hasError('required')">
              Campo requerido
            </mat-error>
          </mat-form-field>
          <div class="text-danger font-11" *ngIf="tipoEquipoList.length == 0">
            Este trabajador no tiene laptop ni celular asignado.
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Sede</mat-label>
            <input matInput formControlName="reportefalla_sede">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Serie / IMEI</mat-label>
            <input matInput formControlName="reportefalla_serie">
          </mat-form-field>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Descripción de Equipo</mat-label>
            <input matInput formControlName="reportefalla_descripcionequipo">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Apellidos y Nombres del Usuario</mat-label>
            <input matInput formControlName="reportefalla_usuario">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Descripción de la Falla</mat-label>
            <textarea matInput formControlName="reportefalla_descripcionfalla" rows="3"></textarea>
            <mat-error *ngIf="fallaForm.get('reportefalla_descripcionfalla').hasError('required')">
              Campo requerido
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Actividades Realizadas</mat-label>
            <textarea matInput formControlName="reportefalla_actividadrealizada" rows="3"></textarea>
            <mat-error *ngIf="fallaForm.get('reportefalla_actividadrealizada').hasError('required')">
              Campo requerido
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width " appearance="outline">
            <mat-label>Responsable de la Atención</mat-label>
            <mat-select formControlName="reportefalla_responsable">
              <mat-option [value]="value" *ngFor="let value of responsablesList">
                {{value}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="fallaForm.get('reportefalla_responsable').hasError('required')">
              Campo requerido
            </mat-error>
          </mat-form-field>
        </div>
      </div>

    </form>
  </div>

  <div mat-dialog-actions>
    <div class="example-button-row">
      <button mat-raised-button color="primary" type="button" [disabled]="fallaForm.invalid || guardando || tipoEquipoList.length == 0"
              (click)="guardar()">Guardar</button>
      <button mat-raised-button color="warn" (click)="onNoClick()" tabindex="-1">Cancelar</button>
    </div>
  </div>

  <div class="m-4" *ngIf="historialList.length > 0">
    <h6><strong>Historial de Reportes de Falla</strong></h6>
    <div class="table-responsive">
      <table class="table table-hover table-sm">
        <thead>
        <tr>
          <th>Fecha</th>
          <th>Equipo</th>
          <th>Serie/IMEI</th>
          <th>Falla</th>
          <th>Responsable</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of historialList">
          <td>{{item.reportefalla_fecha}}</td>
          <td>{{item.reportefalla_tipoequipo}}</td>
          <td>{{item.reportefalla_serie}}</td>
          <td>{{item.reportefalla_descripcionfalla}}</td>
          <td>{{item.reportefalla_responsable}}</td>
          <td>{{item.reportefalla_estado}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="m-4" *ngIf="!cargandoHistorial && historialList.length == 0">
    <span class="font-11 text-muted">Este trabajador no tiene reportes de falla anteriores.</span>
  </div>
</div>
